import {cookie} from '@/utils/cookie';

const TOKEN_KEY = 'access_token';

export const isUserLoggedIn = (): boolean => Boolean(cookie.get(TOKEN_KEY));
